import React from "react";

const ModalInput = (props) => {
  return (
    <input className={`h-10 bg-black-050 ${props.full ? "w-full" : "w-[400px]"} text-black px-2 rounded-lg dark:bg-black-900 dark:text-white`} {...props} />
  );
};

export default ModalInput;
